var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCourier(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7122",
    "data-name": "Rectangle 7122",
    width: 56,
    height: 56,
    transform: "translate(716 509)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Courier",
    transform: "translate(-716 -509)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28320",
    "data-name": "Group 28320",
    transform: "translate(-157.53 -633.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31696",
    "data-name": "Path 31696",
    d: "M921.5,1169.406h.024l-10.669-10.752a1.778,1.778,0,0,0-1.258-.522H881.741a1.778,1.778,0,0,0-1.78,1.78v19.2a1.778,1.778,0,0,0,1.78,1.78h2.765a5.9,5.9,0,0,1,11.8,0h10.206a5.9,5.9,0,0,1,11.8,0h3.489a1.3,1.3,0,0,0,1.305-1.306v-6.124A5.9,5.9,0,0,0,921.5,1169.406Zm-5.174-.095h-7.666a.588.588,0,0,1-.593-.594v-6.575a.587.587,0,0,1,.593-.593h1.127a.556.556,0,0,1,.415.178l6.539,6.575A.591.591,0,0,1,916.323,1169.311Z",
    transform: "translate(0 0)",
    fill: "#3d72fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28321",
    "data-name": "Group 28321",
    transform: "translate(886.642 1177.132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31697",
    "data-name": "Path 31697",
    d: "M893.115,1177.9a3.762,3.762,0,1,1-3.762-3.762A3.763,3.763,0,0,1,893.115,1177.9Z",
    transform: "translate(-885.591 -1174.142)",
    fill: "#3d72fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28322",
    "data-name": "Group 28322",
    transform: "translate(908.644 1177.132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31698",
    "data-name": "Path 31698",
    d: "M911.655,1177.9a3.762,3.762,0,1,1-3.762-3.762A3.763,3.763,0,0,1,911.655,1177.9Z",
    transform: "translate(-904.131 -1174.142)",
    fill: "#3d72fc"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourier);
export default __webpack_public_path__ + "static/media/courier.6de5f86b27cb9fcd9db2f73c0c8ddd84.svg";
export { ForwardRef as ReactComponent };